import { ComponentPropsWithoutRef, createContext, useContext } from "react"

import { MAIN_ID } from "@src/utils/focusPageStart"

const InsideMainLandmarkContext = createContext(false)

export const MainLandmark = ({
  children,
  ...props
}: Omit<ComponentPropsWithoutRef<"main">, "id">) => (
  <InsideMainLandmarkContext.Provider value={true}>
    <main id={MAIN_ID} {...props}>
      {children}
    </main>
  </InsideMainLandmarkContext.Provider>
)

export const OutsideMainLandmark = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const isInsideMainLandmark = useContext(InsideMainLandmarkContext)

  if (isInsideMainLandmark) return <>{children}</>

  return <MainLandmark>{children}</MainLandmark>
}
